<template>
  <div>
    <!--MENUS-->
    <!--Menu - Mobile-->
    <ModalMenuMobile/>

    <!--NOTIFICATIONS-->
    <!--View-->
    <ModalNotification/>

    <!--LEADS-->
    <!--Import Leads-->
    <ModalImportLeads/>
    <!--Add Lead-->
    <ModalAddLead/>
    <!--Search Lead-->
    <ModalSearchLead/>

    <!--LEAD-->
    <!--Show Ticket Lead-->
    <ModalLeadShowTicket/>
    <!--Edit Lead-->
    <ModalEditLead/>

    <!--WALLET-->
    <!--Add Wallet-->
    <ModalAddWallet/>
    <!--Transfer/Edit Wallet-->
    <ModalEditWallet/>

    <!--USER-->
    <!--Add User-->
    <ModalAddUser/>
    <!--Search User-->
    <!-- <ModalSearchUser/> -->
    <!--Change Password-->
    <ModalUserPassword/>
    <!--Operators - Add-->
    <ModalAddOperator/>
    <!--Wallet - Actions-->
    <ModalUserWalletActions/>
    <!--Logs - Differences-->
    <ModalLogsUser/>

    <!--MARKETING-->
    <!--Add Campaign Group-->
    <ModalAddCampaignGroup />
    <!--Search Campaign-->
    <ModalSearchCampaign/>
    <!--Show Campaign-->
    <ModalViewCampaign/>

    <!--REPORTS-->
    <!--Show Reports-->
    <ModalShowReport/>
    <!--Tickets-->
    <ModalSearchTickets/>
    <!--E-mails-->
    <ModalSearchReportEmail/>
    <!--HSM-->
    <ModalSearchReportHsm/>
    <!--SMS-->
    <ModalSearchReportSms/>
    <!--Voip-->
    <ModalSearchReportVoip/>
    <!--NPS-->
    <ModalSearchReportNps/>
    <!--Webhook-->
    <ModalSearchReportWebhook/>
    <ModalReturnPayloadWebhook/>
    <!--Chat-Bot-->
    <ModalSearchReportChatbot />


    <!--TASKS-->
    <!--Add Task-->
    <ModalAddTask/>
    <!--Edit Task-->
    <ModalEditTask/>

    <!--CHANNEL-->
    <!--Add Channel-->
    <ModalAddChannel/>
    <!--Search Channel-->
    <!-- <ModalSearchChannel/> -->
    <!--CHANNEL - TABS-->
    <!--Departments - Add-->
    <ModalAddDepartment/>
    <!--Departments - Edit-->
    <ModalEditDepartment/>
    <!--Operators - Add-->
    <ModalAddChannelOperator/>
    <!--Interests - Add-->
    <ModalAddInterest/>
    <!--Interests - Edit-->
    <ModalEditInterest/>
    <!--Category - Add-->
    <ModalAddCategory/>
    <!--Category - Edit-->
    <ModalEditCategory/>
    <!--Motives - Add-->
    <ModalAddMotive/>
    <!--Motives - Edit-->
    <ModalEditMotive/>
    <!--Replies - Add-->
    <ModalAddReply/>
    <!--Replies - Edit-->
    <ModalEditReply/>
    <!--Tags - Add-->
    <ModalAddTag/>
    <!--Tags - Edit-->
    <ModalEditTag/>
    <!--Chatbot-->
    <ModalAddSubmenuChatBot/>
    <!--Integrations-->
    <ModalIntegrations/>
    <!--Template HSM-->
    <ModalAddTemplateHSM/>
    <ModalExamplePayloadHsm/>
    <!--Plan-->
    <ModalEditPlan/>
    <!--Variables and Formatting-->
    <ModalVariables/>
    <!--Add Token API-->
    <ModalAddToken/>
    <!--Edit Token API-->
<!--    <ModalEditToken/>-->
    <!--Example API-->
    <ModalExampleApi/>

    <!--CHAT-->
    <!--DESKTOP Version-->
    <!--History-->
    <ModalChatHistoryTicket/>
    <!--Transfer Ticket-->
    <ModalChatTransferTicket/>
    <!--Files-->
    <ModalChatFilesTicket/>
    <!--SMS-->
    <ModalChatSms/>
    <!--E-mail-->
    <ModalChatEmail/>
    <!--vCard-->
    <ModalChatVcard/>
    <!--Location-->
    <ModalChatLocation/>
    <!--Voip-->
    <ModalVoIP/>
    <!--HSM-->
    <ModalSendTemplateHSM/>
    <!-- LEAD QUOTES -->
    <ModalAddLeadQuote />
    <!-- ADD TICKET FROM CHAT -->
    <ModalAddTicketFromChat />
    <!--Timeline-->
    <ModalShowStatusesTicket/>
    <!--Alert-->
    <ModalAlertLimitsChat/>

    <!--TICKETS-->
    <!--Show Ticket-->
    <ModalShowTicket/>
    <!--Transfer Ticket-->
    <ModalTransferTicket/>
    <!--Open Ticket-->
    <ModalOpenTicket/>
    <!--Media-->
    <ModalViewMedia/>

    <!--MOBILE Version-->
    <!--Info Contact - Mobile-->
    <ModalChatMobileInfoLead/>

    <!--TESTER-->
    <ModalUpgradeTester v-if="isTester()"/>
    <ModalWizardTester v-if="isTester()"/>

  </div>
</template>

<script>
import ModalImportLeads from "../../components/modals/ModalImportLeads";
import ModalAddLead from "../../components/modals/ModalAddLead";
import ModalSearchLead from "../../components/modals/ModalSearchLead";
import ModalAddUser from "../../components/modals/ModalAddUser";
// import ModalSearchUser from "../../components/modals/ModalSearchUser.vue";
import ModalAddChannel from "../../components/modals/ModalAddChannel";
// import ModalSearchChannel from "../../components/modals/ModalSearchChannel";
import ModalSearchCampaign from "../../components/modals/ModalSearchCampaign";
import ModalSearchTickets from "../../components/modals/ModalSearchTickets";
import ModalAddTask from "../../components/modals/ModalAddTask";
import ModalEditTask from "../../components/modals/ModalEditTask";
import ModalAddSubmenuChatBot from "../../components/modals/ModalAddSubmenuChatBot";
import ModalAddDepartment from "../../components/modals/ModalAddDepartment";
import ModalEditDepartment from "../../components/modals/ModalEditDepartment";
import ModalAddChannelOperator from "../../components/modals/ModalAddChannelOperator";
import ModalAddInterest from "../../components/modals/ModalAddInterest";
import ModalEditInterest from "../../components/modals/ModalEditInterest";
import ModalAddMotive from "../../components/modals/ModalAddMotive";
import ModalEditMotive from "../../components/modals/ModalEditMotive";
import ModalAddReply from "../../components/modals/ModalAddReply";
import ModalEditReply from "../../components/modals/ModalEditReply";
import ModalAddTag from "../../components/modals/ModalAddTag";
import ModalEditTag from "../../components/modals/ModalEditTag";
import ModalLeadShowTicket from "../../components/modals/ModalLeadShowTicket";
import ModalAddWallet from "../../components/modals/ModalAddWallet";
import ModalEditWallet from "../../components/modals/ModalEditWallet";
import ModalEditLead from "../../components/modals/ModalEditLead";
import ModalViewCampaign from "../../components/modals/ModalViewCampaign";
import ModalUserPassword from "../../components/modals/ModalUserPassword";
import ModalAddOperator from "../../components/modals/ModalAddOperator";
import ModalMenuMobile from "../../components/modals/ModalMenuMobile";
import ModalChatHistoryTicket from "../../components/modals/ModalChatHistoryTicket";
import ModalChatTransferTicket from "../../components/modals/ModalChatTransferTicket";
import ModalChatFilesTicket from "../../components/modals/ModalChatFilesTicket";
import ModalChatSms from "../../components/modals/ModalChatSms";
import ModalChatEmail from "../../components/modals/ModalChatEmail";
import ModalChatVcard from "../../components/modals/ModalChatVcard";
import ModalChatLocation from "../../components/modals/ModalChatLocation";
import ModalShowTicket from "../../components/modals/ModalShowTicket";
import ModalChatMobileInfoLead from "../modals/ModalChatMobileInfoLead";
import ModalVoIP from "../modals/ModalVoIP";
import ModalUserWalletActions from "../modals/ModalUserWalletActions";
import ModalTransferTicket from "../modals/ModalTransferTicket";
import ModalIntegrations from "../modals/ModalIntegrations";
import ModalOpenTicket from "../modals/ModalOpenTicket";
import ModalLogsUser from "../modals/ModalLogsUser";
import ModalEditPlan from "../modals/ModalEditPlan";
import ModalAddTemplateHSM from "../modals/ModalAddTemplateHSM";
import ModalVariables from "../modals/ModalVariables";
import ModalNotification from "../modals/ModalNotification";
import ModalViewMedia from "../modals/ModalViewMedia";
import ModalSendTemplateHSM from "../modals/ModalSendTemplateHSM";
import ModalAddLeadQuote from "../modals/ModalAddLeadQuote";
import ModalAddTicketFromChat from "../modals/ModalAddTicketFromChat";
import ModalSearchReportEmail from "../modals/ModalSearchReportEmail";
import ModalSearchReportHsm from "../modals/ModalSearchReportHsm";
import ModalSearchReportSms from "../modals/ModalSearchReportSms";
import ModalSearchReportVoip from "../modals/ModalSearchReportVoip";
import ModalShowReport from "../modals/ModalShowReport";
import ModalSearchReportNps from "../modals/ModalSearchReportNps";
import ModalExampleApi from "../modals/ModalExampleApi";
// import ModalEditToken from "../modals/ModalEditToken";
import ModalAddToken from "../modals/ModalAddToken";
import ModalShowStatusesTicket from "../modals/ModalShowStatusesTicket";
import ModalAlertLimitsChat from "../modals/ModalAlertLimitsChat";
import ModalUpgradeTester from "../modals/ModalUpgradeTester";
import ModalWizardTester from "../modals/ModalWizardTester";
import ModalExamplePayloadHsm from "../modals/ModalExamplePayloadHsm";
import ModalSearchReportWebhook from "../modals/ModalSearchReportWebhook";
import ModalReturnPayloadWebhook from "../modals/ModalReturnPayloadWebhook";
import ModalAddCampaignGroup from "../modals/ModalAddCampaignGroup";
import ModalSearchReportChatbot from "../modals/ModalSearchReportChatbot.vue";
import ModalAddCategory from "../modals/ModalAddCategory.vue";
import ModalEditCategory from "../modals/ModalEditCategory.vue";

export default {
  name: "Modals",
  components: {
    ModalSearchReportChatbot,
    ModalAddCampaignGroup,
    ModalReturnPayloadWebhook,
    ModalSearchReportWebhook,
    ModalExamplePayloadHsm,
    ModalWizardTester,
    ModalUpgradeTester,
    ModalAlertLimitsChat,
    ModalShowStatusesTicket,
    ModalAddToken,
    ModalExampleApi,
    // ModalEditToken,
    ModalSearchReportNps,
    ModalShowReport,
    ModalSearchReportVoip,
    ModalSearchReportSms,
    ModalSearchReportHsm,
    ModalSearchReportEmail,
    ModalSendTemplateHSM,
    ModalAddLeadQuote,
    ModalAddTicketFromChat,
    ModalViewMedia,
    ModalNotification,
    ModalVariables,
    ModalAddTemplateHSM,
    ModalEditPlan,
    ModalLogsUser,
    ModalOpenTicket,
    ModalIntegrations,
    ModalTransferTicket,
    // ModalSearchReportOperator,
    ModalUserWalletActions,
    ModalVoIP,
    ModalChatMobileInfoLead,
    ModalShowTicket,
    ModalChatLocation,
    ModalChatVcard,
    ModalChatEmail,
    ModalChatSms,
    ModalChatFilesTicket,
    ModalChatTransferTicket,
    ModalChatHistoryTicket,
    ModalMenuMobile,
    ModalAddOperator,
    ModalUserPassword,
    ModalViewCampaign,
    ModalEditLead,
    ModalEditWallet,
    ModalAddWallet,
    ModalLeadShowTicket,
    ModalEditTag,
    ModalAddTag,
    ModalEditReply,
    ModalAddReply,
    ModalEditMotive,
    ModalAddMotive,
    ModalEditInterest,
    ModalAddInterest,
    ModalAddCategory,
    ModalEditCategory,
    ModalAddChannelOperator,
    ModalEditDepartment,
    ModalAddDepartment,
    ModalAddSubmenuChatBot,
    ModalEditTask,
    ModalAddTask,
    ModalSearchTickets,
    ModalSearchCampaign,
    // ModalSearchChannel,
    ModalAddChannel,
    // ModalSearchUser,
    ModalAddUser,
    ModalImportLeads,
    ModalAddLead,
    ModalSearchLead,
  }
}
</script>

<style scoped>

</style>
